import Profile from 'arbitrip-common/client/entities/Profile';
export default Profile;
